var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.584 23 12 19.242V1L8.292 8.242 0 9.404l6 5.636L4.585 23Z",
    fill: "currentColor",
    className: "star_svg__left_half"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.708 8.242 12 1v18.242L19.416 23 18 15.04l6-5.636-8.292-1.162Z",
    fill: "currentColor",
    className: "star_svg__right_half"
  })));
};
export default SvgStar;